import { parseHtml } from '../core/utils';
import { useTranslation } from '../core/utils/translations';
// prettier-ignore
import { FacebookBubble, InstagramBubble, YoutubeBubble } from '@cfm-media/pwa-ui-components';
import { ContentWrapper } from '../components/content-wrapper';
import { PageWrapper } from '../components/page-wrapper';

export function About() {
  const { t } = useTranslation('legal-pages');

  return (
    <PageWrapper>
      <ContentWrapper>
        <div className="pwa-content">{parseHtml(t('about'))}</div>

        <div className="flex justify-center pt-5 pb-1 space-x-6 lg:max-w-5xl lg:mx-auto lg:px-6">
          <a href="https://www.instagram.com/bentourreisen/" target="_blank">
            <InstagramBubble
              color="#881467"
              instagramBubbleDimensions="w-16 h-16"
            />
          </a>
          <a href="https://www.facebook.com/BentourReisen" target="_blank">
            <FacebookBubble
              color="#881467"
              facebookBubbleDimensions="w-16 h-16"
            />
          </a>
          <a
            href="https://www.youtube.com/user/BentourSwiss"
            target="_blank"
            className="pt-[3px]"
          >
            <YoutubeBubble
              color="#881467"
              youtubeBubbleDimensions="w-20 h-20"
            />
          </a>
        </div>
      </ContentWrapper>
    </PageWrapper>
  );
}
